<template>
  <v-dialog persistent width="480" v-model="active">
    <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
      <v-card-title class="ui-evaluation-card-title header-verde">
        <div class="text-h6 font-weight-bold">Turnar aspirante</div>
      </v-card-title>
      <v-card-text>
        <v-radio-group v-model="opcionAspirante" class="ui-radio-group">
          <v-radio value="1" label="Asignar como cadete" color="secondary"></v-radio>
          <v-radio value="2" label="Descartar aspirante" color="error"></v-radio>
        </v-radio-group>
      </v-card-text>
      <v-card-actions class="ui-module-actions justify-center">
        <v-btn text class="ui-btn-cancel" @click="closeDialog()">Cancelar</v-btn>
        <v-btn class="ui-module-btn-solid" @click="triggerActualizaAspirante" :loading="loading" :disabled="loading"
          >Guardar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    active: {
      type: Boolean,
    },

    aspirante: {
      type: Object,
    },
  },

  data() {
    return {
      opcionAspirante: '1',
      loading: false,
    }
  },

  methods: {
    ...mapActions('personal', ['updateEstatusPersonal', 'updatePuestoPersonal']),
    ...mapActions('preaspirante', ['fetchAspirantes']),
    ...mapActions('aspirantes', ['updateAspiranteReclutedToPolicia']),

    closeDialog() {
      this.$emit('close')
      this.loading = false
    },

    async triggerActualizaAspirante() {
      this.loading = true

      if (this.opcionAspirante == '1') {
        await this.updatePuestoPersonal({
          idPersonal: this.aspirante.idPersonal,
          fk_idPuestoDependencia: 28,
        })
        await this.updateEstatusPersonal({
          idPersonal: this.aspirante.idPersonal,
          fk_idEstatus: 1,
        })

        await this.updateAspiranteReclutedToPolicia({
          idPersonal: this.aspirante.idPersonal,
          reclutadoPolicial: true,
        })
      } else {
        await this.updateEstatusPersonal({
          idPersonal: this.aspirante.idPersonal,
          fk_idEstatus: 6,
        })
      }

      await this.fetchAspirantes()

      this.closeDialog()
    },
  },
}
</script>

<style scoped>
.ui-evaluation-card-title {
  color: #e0e0e0 !important;
  font-weight: 700;
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb), 0.2);
}

.header-verde {
  background: rgba(38, 222, 129, 0.15) !important;
  color: #26de81 !important;
  border-bottom: 1px solid rgba(38, 222, 129, 0.35) !important;
}

::v-deep .ui-radio-group .v-label {
  color: #e0e0e0 !important;
}

.ui-module-actions .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s ease;
}

.ui-module-btn-solid {
  padding-left: 24px !important;
  padding-right: 24px !important;
  background: linear-gradient(135deg, var(--v-secondary-base) 0%, var(--v-secondary-lighten1) 100%) !important;
  color: #08130f !important;
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb), 0.28) !important;
}

.ui-module-btn-solid:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(var(--v-secondary-base-rgb), 0.25) !important;
}

.ui-btn-cancel {
  color: #ff5252 !important;
}
</style>
